import { create } from "zustand"

interface LinkTherapistModalStore {
  isOpen: boolean
  onOpen: (hasCode?: boolean) => void
  onClose: () => void

  hasCode: boolean
  setHasCode: (hasCode: boolean) => void
}

export const useLinkTherapistModalStore = create<LinkTherapistModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: (hasCode = false) => set({ isOpen: true, hasCode }),
    onClose: () => set({ isOpen: false }),

    hasCode: false,
    setHasCode: (hasCode) => set({ hasCode }),
  })
)
